(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('VirtualFairsListController', VirtualFairsListController);

    VirtualFairsListController.$inject = ['virtualFairsList', 'ExpoService', '$uibModal'];

    function VirtualFairsListController(virtualFairsList, ExpoService, $uibModal) {
        var vm = this;

        vm.virtualFairs = virtualFairsList.data.data;


        vm.getByFilter     = getByFilter;
        vm.openInformation = openInformation;


        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.totalItems   = virtualFairsList.data.total;
        vm.currentPage  = virtualFairsList.data.current_page;
        vm.itemsPerPage = virtualFairsList.data.per_page;
        vm.page         = 1;


        function setPage(page) {
            vm.currentPage = page;
        };


        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        };


        function getByFilter() {
            vm.query = {};
            vm.query['paginate'] = true;
            vm.query['page'] = vm.page;

            ExpoService.getExposVirtualFair(vm.query).then(function(response) {
                vm.virtualFairs = response.data.data;
                vm.itemsPerPage = response.data.per_page;
                vm.totalItems   = response.data.total;
                vm.setPage(response.data.current_page);

            }).catch(function(err) {
            });
        }


        function openInformation(virtualfair) {
            $uibModal.open({
                templateUrl: 'templates/virtualfairs/show/show.modal.html',
                controller: 'VirtualFairShowController',
                controllerAs:'vm',
                resolve: {
                    virtualfair: function() {
                        return virtualfair;
                    }
                }
            });
        }
    }

})();